import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-800 border-t border-slate-700 mt-auto">
      <div className="container-custom py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-slate-400 text-sm">
            © 2025 Ishan Jaiswal
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;